<script lang="ts">
  /* The tile cache. A DIAGNOSTIC, not a chart control — which is why it is last
     in the rail and behind MORE on a phone rather than owning a slot in the
     top-right corner of every desktop, as it did. */
  import CachePanel from '@gennetay/chart-ui/CachePanel';
</script>

<div class="flush"><CachePanel /></div>

<style>
  /* Flush inside the panel: a bordered card within a bordered surface reads as
     two panels rather than one section of one. The panel is the surface. */
  .flush :global(.cache) {
    background: none;
    border: 0;
    border-radius: 0;
    padding: 0;
  }
</style>
